import store from '../store';
import router from '../router';
import axios from 'axios';

class InternalTracker {
  constructor() {
    this.initialised = false;
    this.consoleFn = {};
    this.index = 0;
    this.url = 'https://wm-ingest.pscs.co.uk/webmailhook';
    this.buffer = [];
    this.timer = null;
  }

  init() {
    this.initialised = true;

    router.afterEach((to, from) => {
      if (store.state.internalTrackEnabled) {
        let params = {
          action: 'route',
          index: this.index++,
          to: { name: to.name, path: to.path },
          from: { name: from.name, path: from.path }
        };
        this.add(params);
      }
    });

    console.log = (() => {
      const log = console.log;
      const this_ = this;
      return function() {
        log.apply(console, arguments);
        this_.trackConsole('log', arguments);
      };
    })();
    console.warn = (() => {
      const warn = console.warn;
      // const this_ = this;
      return function() {
        warn.apply(console, arguments);
        // this_.trackConsole('warn', arguments);
      };
    })();
    console.error = (() => {
      const error = console.error;
      const this_ = this;
      return function() {
        error.apply(console, arguments);
        this_.trackConsole('error', arguments);
      };
    })();
  }

  add(params) {
    this.buffer.push(params);
    if (this.timer) {
      clearTimeout(this.timer);
    }
    if (this.buffer.length > 100) {
      this.sendBuffer();
    } else {
      this.timer = setTimeout(() => { this.sendBuffer(); }, 1000);
    }
  }

  sendBuffer() {
    axios.post(this.url, {
      guid: localStorage.getItem('serverGuid'),
      auth: localStorage.getItem('token'),
      buffer: this.buffer
    });
    this.buffer = [];
  }

  trackConsole(type, args) {
    if (store.state.internalTrackEnabled) {
      const params = {
        action: type,
        index: this.index++,
        args: Object.keys(args).map(k => {
          switch (args[k]) {
            case undefined:
              return '<undefined>';
            case null:
              return '<null>';
            default:
              return args[k].toString();
          }
        })
      };
      this.add(params);
    }
  }
}

export default new InternalTracker();
